import { Box, type BoxProps } from "@mui/material";
import { mergeSxProps } from "@src/appV2/redesign/system/ui-components";

// FIXME: Automatically disabled during ESLint config update
export interface CalendarGridSectionWrapperProps extends BoxProps {}

export function CalendarGridSectionWrapper(props: CalendarGridSectionWrapperProps) {
  const { sx, ...restProps } = props;

  return (
    <Box
      sx={mergeSxProps(
        {
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          rowGap: 3,
        },
        sx
      )}
      {...restProps}
    />
  );
}
